import React from "react";


import { connect } from "react-redux";
import CommonTitleHeader from "../commonTitleComponent/commonTitleHeader";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import PaymentFilter from "./PaymentFilter";
import PaymentStaticTxt from "./PaymentStaticTxt";


class BankToBankDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }


    render(){
    console.log('Inside render');
    return(
        <div class="col-12">
        <div class="card">
        
        <div class="banksteps">
                    <ul>
                        <li>
                            <i class="step1"></i>
                            <h6>Login to bank account and <br/>go to "Fund Transfer"</h6>
                            <span class="steparrow"></span>
                        </li>
                        <li>
                            <i class="step2"></i>
                            <h6>Click on Add Beneficiary or <br/>Register a new Payee</h6>
                            <span class="steparrow"></span>
                        </li>
                        <li>
                            <i class="step3"></i>
                            <h6>Select Other* Bank NEFT/RTGS <br/>transfer and enter the amount</h6>
                            <span class="steparrow"></span>
                        </li>
                        <li>
                            <i class="step4"></i>
                            <h6>Click on "Confirm" button to <br/>complete the transaction</h6>
                        </li>
                    </ul>
        </div>
        
        </div>
    </div>	
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(BankToBankDetails);
